<template lang='pug'>
v-data-table(
  :loading='isLoading'
  :headers='headers'
  :items='deals'
  :hide-actions='true'
)
  template(slot='items' slot-scope='props')
    tr(class='with-pointer')
      td(data-label='№ Договора') {{ props.item.num }}
      td(data-label='Объект')
        | {{ props.item.accomodation_type }},
        | {{ props.item.object_name }},
        | №{{ props.item.number }}
      td(data-label='Цена' class='wrapless') {{ props.item.price | rubles }}
      td(data-label='Регистрация')
        | №{{ props.item.reg_number }}
        span(class='wrapless') от {{ props.item.reg_date | date}}
      td(data-label='Менеджер') {{ props.item.manager }}
      td(data-label='Тип контракта') {{ props.item.type_of_contract }}
      td(class='crud-tools')
        v-menu(v-if='props.item.share_info' transition='slide-x-transition')
          v-btn(color='primary' slot='activator' flat icon)
            v-icon info
          v-list(dense)
            v-list-tile(v-for='(r, i) in props.item.share_info' :key='i')
              v-list-tile-content(class='pr-5 grey--text') {{ r.key }}
              v-list-tile-content(class='align-end') {{ r.val }}
</template>

<script>
export default {
  props: ['deals', 'isLoading'],

  data: () => ({
    headers: [
      { text: '№ Договора', sortable: false },
      { text: 'Объект', sortable: false },
      { text: 'Цена', sortable: false },
      { text: 'Регистрация', sortable: false },
      { text: 'Менеджер', sortable: false },
      { text: 'Тип контракта', sortable: false },
      { text: '', sortable: false, class: 'crud-tools' }
    ]
  })
}
</script>
